/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Plan_Change_Keep_Option_HintInputs */

const fr_membership_plan_change_keep_option_hint = /** @type {(inputs: Membership_Plan_Change_Keep_Option_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sans l'option, vous perdrez l'accès 6h-23h à partir du ${i?.date}.`)
};

/**

* @param {Membership_Plan_Change_Keep_Option_HintInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_keep_option_hint = /** @type {((inputs: Membership_Plan_Change_Keep_Option_HintInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Keep_Option_HintInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_keep_option_hint(inputs)
});